import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import { cpOrganizationStore, organizationService } from "../../api";
import { enums } from "../../base";
import AuthorizedComponent from "../authorized-component";
import { CpDataSourceModel, OrganizationRef } from "../../models";
import React from "react";
import { ContentBlock, StdGrid, StdToolbar, createGridOptions, setColumnDataSource, stdReadOnlyGridOptions } from "../../components";
import { InitNewRowEvent, SelectionChangedEvent } from "devextreme/ui/data_grid";

interface CpOrganizationState {
    data: CpDataSourceModel[];
    orgs: OrganizationRef[];
    columns: IColumnProps[];
}

export default class CpOrganizationPage extends AuthorizedComponent<any, CpOrganizationState> {
    objectName = "CpDataSource";
    moduleName = "CpDataSource";
    gridRef = React.createRef<DataGrid>();
    toolbarRef = React.createRef<StdToolbar>();
    gridOptions = createGridOptions("cpDataSources", this.gridRef, stdReadOnlyGridOptions);

    constructor(props: Readonly<any>) {
        super(props);

        this.state = {
            data: [],
            orgs: [],
            columns: [
                { 
                    dataField: "createdAt",
                    formItem: { visible: false },
                    dataType: 'datetime' 
                },
                { 
                    dataField: "updatedAt", 
                    formItem: { visible: false },
                    dataType: 'datetime' 
                },
                { dataField: "text" },
                {
                    dataField: "extra",
                    caption: "所属配送系统站点",
                    lookup: { dataSource: [], displayExpr: 'name', valueExpr: 'id' }
                }
            ]
        };

        this.gridOptions.keyExpr = "id";
        this.gridOptions.onInitNewRow = this.onInitNewRow.bind(this);
        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = e => this.onButtonClick(e.data, "edit");
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    componentDidMount(): void {
        super.componentDidMount();
        this.loadOrgs();
    }

    async loadOrgs() {
        const orgs = await organizationService.getAllRefs();
        setColumnDataSource(this.state.columns, "extra", orgs);
        this.setState({ orgs: orgs });
    }

    onInitNewRow(e: InitNewRowEvent) {
        e.data.type = enums.cpDataSourceTypes.organization;
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.toolbarRef.current?.setModel(e.selectedRowsData[0]);
        } else {
            this.toolbarRef.current?.setModel({});
        }
    }

    onButtonClick(model: CpDataSourceModel, name: string) {
        const grid = this.gridRef.current?.instance;
        
        if (grid) {
            switch (name) {
                case "add":
                    if (this.permissions[enums.stdActions.create]) {
                        grid.addRow();
                    }
                    break;

                case "edit":
                    if (this.permissions[enums.stdActions.update]) {
                        grid.editRow(grid.getRowIndexByKey(model.id));
                    }
                    break;
                
                case "delete":
                    if (this.permissions[enums.stdActions.delete]) {
                        grid.deleteRow(grid.getRowIndexByKey(model.id));
                    }
                    break;
            }
        }
    }

    render() {
        return (
            <ContentBlock caption={"条码打印-站点档案"}>
                <StdToolbar 
                    permissions={this.permissions}
                    ref={this.toolbarRef} 
                    onButtonClick={this.onButtonClick} />
                <StdGrid
                    moduleName={this.moduleName}
                    gridRef={this.gridRef}
                    dataSource={cpOrganizationStore}
                    options={this.gridOptions}
                    columns={this.state.columns}
                    popupWidth={400}
                    popupHeight={280}
                    formColCount={1} />
            </ContentBlock>
        );
    }
}